<div class="container_dialog">
    <div class="header_popup">
        <div class="title_popup">
            <span>{{"import.imported_succeces"|translate}}</span>
        </div>
        <button (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <form novalidate="" class="display_form ng-untouched ng-pristine ng-invalid">
        <div class="display_block">
            <div class="img_block">
                <div class="drop_zone">
                    <span class="inside_block"></span>
                    <span class="text_zone">{{"import.congrat_youve_file"|translate}} <span class="success">{{data.length}}</span> {{"inventory.products"|translate}}</span>
                </div>
                <div class="image_preview_container"></div>
            </div>
        </div>
    </form>
    <div class="submet_btns">
        <button class="save_btn_pop_up cancel_btn_pop_up" (click)="close()">
            <span>{{"common.close"|translate}}</span>
        </button>
    </div>
</div>
